const _isBindingAFunction = (binding, vNode) => {
  if (typeof binding.value === "function") {
    return true;
  }

  const componentName = vNode.context.name;
  let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
  if (componentName) {
    warn += `Found in component '${componentName}'`;
  }
  console.warn(warn); // eslint-disable-line no-console
};

export default {
  bind(el, binding, vNode) {
    if (!_isBindingAFunction(binding, vNode)) {
      return;
    }

    const clickHandler = event => {
      const isClickedOutside = !el.contains(event.target) && el !== event.target;
      const isNotificationClicked = event.target.classList.contains("notification-title");
      if (isClickedOutside && !isNotificationClicked) {
        binding.value(event);
      }
    };

    el.__vueClickOutside__ = clickHandler;
    document.addEventListener("click", clickHandler);
  },

  unbind(el) {
    document.removeEventListener("click", el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
};
